
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import moment from "moment";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import CategorySelect from "@/components/CategorySelect/index.vue";
import SearchPopup from "./SearchPopup.vue";
import CustomTable from "@/components/CustomTable/index.vue";
import { Getter } from "vuex-class";
import {
  getWorkbenchGoodsRank,
  getWorkbenchGoodsRankShop,
} from "@/api/shouyin";

@Component({
  components: { CategorySelect, DimensionSelect, SearchPopup, CustomTable },
})
export default class GoodsRankingDetail extends Vue {
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;
  @Getter companyId!: string;
  params: Record<string, any> = {};

  keyValue = "";
  dimension = "门店";
  dimensionValue = "1";
  showTotal = false;
  category: Record<string, string> = {
    categoryName: "全部分类",
    categoryId: "all",
  };
  isInit = false;
  searchRes = null;

  columnsScroll = [
    {
      key: "goodsName",
      title: "商品名称",
      width: "120",
      textOverflow: "ellipsis",
      fixed: 'left'
    },
    {
      key: "totalSaleMoney",
      title: "总额",
      align: "right",
      dataType: "amount",
      sort: true,
      order: "",
    },
    {
      key: "totalSaleAmount",
      title: "数量",
      sort: true,
      order: "",
      align: "right",
    },
    {
      key: "avgTotalSaleMoney",
      title: "平均售价",
      align: "right",
      dataType: "amount",
    },
    {
      key: "price",
      title: "零售价", // 微店价
      align: "right",
      dataType: "amount",
    },
    {
      key: "grossprofit",
      title: "毛利润",
      align: "right",
    },
    {
      key: "sellUnit", // sellUnitWay
      title: "销售规格",
      align: "right",
      dataType: "sellUnitWay",
    },
    {
      key: "avgDiscount",
      title: "平均折扣",
      align: "right",
      dataType: "discount",
    },
  ];
  tableDataSource = [];

  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  handleBack() {
    const { isCategory } = this.$route.query;

    if (isCategory === "1") {
      window.localStorage.setItem("isGoodsRankingGoback", "1");
    } else {
      window.localStorage.setItem("isGoodsRankingGoback", "0");
    }
    this.$router.back();
  }

  async getData() {
    if (!this.params.storeId && !this.multiStoreList.length) return;
    if (!this.params.queryTimeBegin) return;
    const paramsT: any = {
      ...this.params,
      keyValue: this.keyValue,
      pageSize: 1000,
      pageIndex: 1,
    };
    this.isInit = false;
    this.tableDataSource = [];
    let res: any;
    if (this.isMultiStore) {
      paramsT.storeList = this.multiStoreList.map((item) => {
        return { storeId: item };
      });
      if (this.category.storeId && this.category.storeId !== "") {
        paramsT.storeList = paramsT.storeList.filter(
          (item) => item.storeId === this.category.storeId
        );
      }
      res = await getWorkbenchGoodsRankShop(paramsT, true);
    } else {
      res = await getWorkbenchGoodsRank(paramsT, true);
    }
    if (res.code === "000000") {
      this.tableDataSource = res.data.records;
      console.log("查询商品排行 **", res);
    }
    this.isInit = true;
  }

  onDimensionConfirm(value: string, orderType: string) {
    this.dimension = value;
    // 设置参数
    this.params = {
      ...this.params,
      orderType: orderType,
      categoryId: "",
    };
    this.category = {
      categoryName: "全部分类",
      categoryId: "all",
      storeId: "",
      storeName: "",
    };
    let title = "零售价";
    if (orderType === "0") {
      title = "微店价";
    }
    const priceColumn = this.columnsScroll.find((item) => item.key === "price");
    if (priceColumn) {
      priceColumn.title = title;
    }
  }
  onCategoryConfirm(value: any) {
    // console.log("value22222", value);
    this.category = value;
    if (["门店商品", "微店商品", "全部分类"].includes(value.categoryName)) {
      if (this.isMultiStore) {
        this.params = {
          ...this.params,
          storeId: value.storeId,
          categoryId: "",
        };
      } else {
        this.params.categoryId = "";
      }

      return;
    }

    // console.log("value22222", value, this.params);
    if (this.isMultiStore) {
      this.params = {
        ...this.params,
        storeId: value.storeId,
        categoryId: value.categoryId,
      };
    } else {
      this.params = {
        ...this.params,
        categoryId: value.categoryId,
      };
    }
  }
  onSearchConfirm(res) {
    this.searchRes = res;
    const { starttime, endtime } = res;
    this.params = {
      ...this.params,
      queryTimeEnd: `${endtime} 23:59:59`,
      queryTimeBegin: `${starttime} 00:00:00`,
    };
  }
  toSearchShop(keyword: string) {
    this.getData();
  }
  orderByColumn(item: any) {
    this.params.orderKey = item.order === "" ? "" : item.key;
    this.params.orderBy = item.order === "" ? "" : item.order;

    this.getData();
  }
  mounted() {
    const pObj: Record<string, any> = {
      queryTimeEnd: `${moment().format("YYYY-MM-DD")} 23:59:59`,
      queryTimeBegin: `${moment().format("YYYY-MM-DD")} 00:00:00`,
      orderType: "1",
      storeId: !this.isMultiStore ? this.companyId : "",
    };
    const { isWorkbench, isCategory } = this.$route.query;
    if (isWorkbench !== "1" && isCategory !== "1") {
      this.params = pObj;
      return;
    }
    let paramsStr = "";
    // 工作台过来
    if (isWorkbench === "1") {
      paramsStr = window.localStorage.getItem("WorkbenchParams");
    }
    // 类别占比过来
    if (isCategory === "1") {
      paramsStr = window.localStorage.getItem("CategoryParams");
    }

    if (paramsStr && paramsStr !== "") {
      const workbenchParams = JSON.parse(paramsStr);

      if (workbenchParams.searchRes) {
        const searchRes = workbenchParams.searchRes;

        pObj.queryTimeEnd = `${searchRes.endtime} 23:59:59`;
        pObj.queryTimeBegin = `${searchRes.starttime} 00:00:00`;
        this.searchRes = searchRes;
      }
      if (workbenchParams.dimension) {
        pObj.orderType = workbenchParams.dimension.orderType;
        this.dimension = workbenchParams.dimension.text;
      }
      if (workbenchParams.category) {
        this.category = {
          categoryId: workbenchParams.category.categoryId as string,
          categoryName: workbenchParams.category.categoryName as string,
        };
        pObj.categoryId = workbenchParams.category.categoryId;
      }
      if (workbenchParams.storeObj && workbenchParams.storeObj.storeId) {
        this.category.storeId = workbenchParams.storeObj.storeId as string;
        this.category.storeName = workbenchParams.storeObj.storeName as string;
      }
    }
    this.params = pObj;
  }
}
